import type { OrganizationSiteV2 } from '@rtkwlf/rendall';

export enum SitesFormType {
  View = 'View',
  Edit = 'Edit',
  New = 'New',
  Cloned = 'Cloned',
}

export type FormSectionProps = {
  siteFormType: SitesFormType;
};

// omit is done because we need to convert string from textArea to array
export interface SiteFormInputs extends Omit<OrganizationSiteV2, 'ipSubnets'> {
  noDHCP?: boolean;
  noDNS?: boolean;
  noFirewalls?: boolean;
  hasSensors?: string;
  hasEssentialLogSources?: string;
  ipSubnets: string;
  bandwidthUnit?: string;
  otherFirewalls?: string;
  otherDhcp?: string;
  otherDns?: string;
  otherProxy?: string;
  otherSwitches?: string;
}
